import { FieldMapping } from "./fieldMapping";

export const eforceSchemaMapping: Record<string, FieldMapping> = {
  // --- Top Level Fields ---
  "Synopsis": {
    widget: "TextareaWidget",
    fullWidth: true,
    options: { rows: 4 }
  },
  
  // Location Group
  "Address": {
    widget: "TextWidget",
    fullWidth: true
  },
  "Apartment": { widget: "ShortTextWidget", colSpan: 4 },
  "City": { widget: "SelectWidget", colSpan: 4 },
  "State": { widget: "ShortTextWidget", colSpan: 2 },
  "PostalCode": { widget: "ShortTextWidget", colSpan: 2 },
  
  "County": { widget: "ShortTextWidget", colSpan: 4 },
  "GridCode": { widget: "SelectWidget", colSpan: 4 },
  "SubgridCode": { widget: "SelectWidget", colSpan: 4 },
  
  "MilePost": { widget: "NumberWidget", colSpan: 4 },
  "Latitude": { widget: "NumberWidget", colSpan: 4 },
  "Longitude": { widget: "NumberWidget", colSpan: 4 },
  
  // Time Group
  "IncidentDateFrom": { widget: "DateTimeWidget", colSpan: 6 },
  "IncidentTimeFrom": { widget: "TimeWidget", colSpan: 6 },
  
  "IncidentDateTo": { widget: "DateTimeWidget", colSpan: 6 },
  "IncidentTimeTo": { widget: "TimeWidget", colSpan: 6 },
  
  "ReportedDate": { widget: "DateTimeWidget", colSpan: 6 },
  "ReportedTime": { widget: "TimeWidget", colSpan: 6 },
  
  "DispatchTime": { widget: "TimeWidget", colSpan: 4 },
  "ArrivedTime": { widget: "TimeWidget", colSpan: 4 },
  "CompletedTime": { widget: "TimeWidget", colSpan: 4 },

  // Admin Group
  "HowReported": { widget: "SelectWidget", colSpan: 6 },
  "DispositionCode": { widget: "SelectWidget", colSpan: 6 },
  
  "InitialInvestigator": { widget: "ShortTextWidget", colSpan: 6 },
  "InitialTeamId": { widget: "NumberWidget", colSpan: 6 },
  
  // Flags Group
  "Accident": { widget: "ShortCheckboxWidget", colSpan: 3 },
  "HazardousMaterial": { widget: "ShortCheckboxWidget", colSpan: 3 },
  "NuclearMaterial": { widget: "ShortCheckboxWidget", colSpan: 3 },
  "CommercialVehicle": { widget: "ShortCheckboxWidget", colSpan: 3 },

  // --- Nested Definitions ---
  
  // Narrative Definition
  "Narratives": {
      properties: {
          "Type": { 
              colSpan: 12, 
              widget: "SelectWidget"
          },
          "Text": {
              widget: "NarrativeWidget",
              fullWidth: true,
              colSpan: 12,
              options: { rows: 10 }
          },
          "DateWritten": { widget: "DateTimeWidget", colSpan: 6 },
          "WrittenByOfficer": { widget: "ShortTextWidget", colSpan: 6 }
      }
  },

  // Classification
  "Classifications": {
      properties: {
          "Class": { colSpan: 6, widget: "SelectWidget" },
          "SubClass": { colSpan: 6, widget: "SelectWidget" },
          "Completion": { 
              colSpan: 6,
              widget: "SelectWidget"
          },
          "Premise": { colSpan: 6, widget: "SelectWidget" },
          "PointOfEntry": { 
              fullWidth: true,
              widget: "TagSelectWidget"
          },
          "MethodOfEntry": { 
              fullWidth: true,
              widget: "TagSelectWidget"
          },
          "SuspectedUsing": { 
              fullWidth: true,
              widget: "TagSelectWidget"
          }
      }
  },

  // Property Definition (new)
  "Properties": {
      properties: {
          "RecordType": { colSpan: 4, widget: "SelectWidget" },
          "StatusCode": { colSpan: 6, widget: "SelectWidget" },
          "TypeCode": { colSpan: 6, widget: "SelectWidget" },
          "ReportedDate": { widget: "DateTimeWidget", colSpan: 6 },
          "RecoveryReceivedDate": { widget: "DateTimeWidget", colSpan: 6 },
          "Brand": { widget: "ShortTextWidget", colSpan: 6 },
          "Model": { widget: "ShortTextWidget", colSpan: 6 },
          "SerialNumber": { widget: "ShortTextWidget", colSpan: 6 },
          "OwnerAppliedNumber": { widget: "ShortTextWidget", colSpan: 6 },
          "StolenValue": { widget: "NumberWidget", colSpan: 4 },
          "RecoveredValue": { widget: "NumberWidget", colSpan: 4 },
          "DamagedValue": { widget: "NumberWidget", colSpan: 4 },
          "Location": { widget: "ShortTextWidget", fullWidth: true },
          "Quantity": { widget: "NumberWidget", colSpan: 6 },
          "OfficerEnteredBy": { widget: "ShortTextWidget", colSpan: 6 },
          "PrimaryColor": { colSpan: 6, widget: "SelectWidget" },
          "SecondaryColor": { colSpan: 6, widget: "SelectWidget" },
          "CommentText": {
              widget: "TextareaWidget",
              fullWidth: true,
              options: { rows: 3 }
          }
      }
  },

  // Person (Used in Victim, Suspect, OtherInvolved)
  "Person": {
      properties: {
          "FirstName": { widget: "ShortTextWidget", colSpan: 3 },
          "MiddleName": { widget: "ShortTextWidget", colSpan: 3 },
          "LastName": { widget: "ShortTextWidget", colSpan: 3 },
          "Suffix": { widget: "ShortTextWidget", colSpan: 3 },
          
          "Sex": {
              colSpan: 4,
              widget: "SelectWidget"
          },
          "Race": { colSpan: 4, widget: "SelectWidget" },
          "Ethnicity": {
              colSpan: 4,
              widget: "SelectWidget"
          },
          
          "DateOfBirth": { widget: "DateWidget", colSpan: 6 },
          "ResidentStatus": { colSpan: 6, widget: "SelectWidget" },

          "Height": { widget: "NumberWidget", colSpan: 6 },
          "Weight": { widget: "NumberWidget", colSpan: 6 },

          "HairColor": {
              colSpan: 6,
              widget: "SelectWidget"
          },
          "EyeColor": {
              colSpan: 6,
              widget: "SelectWidget"
          },
          
          "SocialSecurity": { widget: "ShortTextWidget", colSpan: 6 },
          "MiscellaneousId": { widget: "ShortTextWidget", colSpan: 6 },
          
          "StreetAddress": { widget: "ShortTextWidget", fullWidth: true },
          "Apartment": { widget: "ShortTextWidget", colSpan: 4 },
          "City": { widget: "ShortTextWidget", colSpan: 4 },
          "State": { widget: "ShortTextWidget", colSpan: 2 },
          "PostalCode": { widget: "ShortTextWidget", colSpan: 2 },
          
          "HomePhone": { widget: "ShortTextWidget", colSpan: 4 },
          "WorkPhone": { widget: "ShortTextWidget", colSpan: 4 },
          "CellPhone": { widget: "ShortTextWidget", colSpan: 4 },
          "Email": { widget: "ShortTextWidget", fullWidth: true },
          
          "OperatorLicense": { widget: "ShortTextWidget", colSpan: 4 },
          "OperatorLicenseState": { widget: "ShortTextWidget", colSpan: 4 },
          "OperatorLicenseExpiration": { widget: "ShortTextWidget", colSpan: 4 },
          "IsOperatorLicenseCommercial": { widget: "ShortCheckboxWidget", colSpan: 6 },
          "IsOperatorLicenseSuspended": { widget: "ShortCheckboxWidget", colSpan: 6 },
          
          "DetailsComments": {
              widget: "TextareaWidget",
              fullWidth: true,
              options: { rows: 3 }
          },
          "AlsoKnownAs": { 
              fullWidth: true,
              items: {
                  "First": { widget: "ShortTextWidget", colSpan: 4 },
                  "Middle": { widget: "ShortTextWidget", colSpan: 4 },
                  "Last": { widget: "ShortTextWidget", colSpan: 4 }
              }
          },
          "ScarsMarksTatoos": { 
              fullWidth: true,
              items: {
                  "Type": { colSpan: 6, widget: "SelectWidget" },
                  "Description": { widget: "ShortTextWidget", colSpan: 6 }
              }
          }
      }
  },

  // Victim Definition
  "Victims": {
      properties: {
          "VictimType": { 
              colSpan: 12,
              widget: "SelectWidget"
          },
          "DateEntered": { widget: "DateTimeWidget", colSpan: 6 },
          "DateReported": { widget: "DateTimeWidget", colSpan: 6 },
          "Person": { fullWidth: true, colSpan: 12 },
          "VictimComments": {
              widget: "TextareaWidget",
              fullWidth: true,
              options: { rows: 3 }
          },
          "Injuries": { 
              fullWidth: true,
              widget: "TagSelectWidget"
          }
      }
  },

  // Suspect Definition
  "Suspects": {
      properties: {
          "SuspectDescription": { colSpan: 6, widget: "SelectWidget" },
          "SuspectGang": { colSpan: 6, widget: "SelectWidget" },
          "DateEntered": { widget: "DateTimeWidget", colSpan: 6 },
          "DateReported": { widget: "DateTimeWidget", colSpan: 6 },
          "Person": { fullWidth: true },
          "SuspectComments": {
              widget: "TextareaWidget",
              fullWidth: true,
              options: { rows: 3 }
          },
          "HairType": { colSpan: 4, widget: "SelectWidget" },
          "HairStyle": { colSpan: 4, widget: "SelectWidget" },
          "FacialHair": { colSpan: 4, widget: "SelectWidget" },
          "SuspectComplexion": { colSpan: 4, widget: "SelectWidget" },
          "Build": { colSpan: 4, widget: "SelectWidget" },
          "Appearance": { colSpan: 4, widget: "SelectWidget" },
          "Speech": { colSpan: 4, widget: "SelectWidget" },
          "Voice": { colSpan: 4, widget: "SelectWidget" },
          "Teeth": { colSpan: 4, widget: "SelectWidget" },
          "OtherClothing": { colSpan: 6, widget: "SelectWidget" },
          "CostumeOrMask": { colSpan: 6, widget: "SelectWidget" },
          "Demeanor": { colSpan: 6, widget: "SelectWidget" },
          "SuspectActions": { colSpan: 6, widget: "SelectWidget" },
          "InjuryThreats": { colSpan: 6, widget: "SelectWidget" },
          "MethodOfTravel": { colSpan: 6, widget: "SelectWidget" },
          "WeaponUsed": { widget: "ShortCheckboxWidget", colSpan: 4 },
          "WeaponType": { colSpan: 4, widget: "SelectWidget" },
          "AutomaticWeapon": { widget: "ShortCheckboxWidget", colSpan: 4 },
          "WeaponCaliber": { colSpan: 6, widget: "ShortTextWidget" },
          "WeaponBarrelLength": { colSpan: 6, widget: "ShortTextWidget" },
          "IsUnknown": { widget: "ShortCheckboxWidget", colSpan: 12 },
          "ArrestDetails": { fullWidth: true }
      }
  },

  // OtherInvolved Definition
  "OtherInvolved": {
      properties: {
          "NameType": { 
              colSpan: 12, 
              widget: "SelectWidget"
          },
          "DateEntered": { widget: "DateTimeWidget", colSpan: 6 },
          "DateReported": { widget: "DateTimeWidget", colSpan: 6 },
          "Person": { fullWidth: true },
          "Comment": {
              widget: "TextareaWidget",
              fullWidth: true,
              options: { rows: 3 }
          }
      }
  },

  // Vehicle Specific
  "Vehicles": {
      properties: {
          "PlateNumber": { widget: "ShortTextWidget", colSpan: 4 },
          "PlateState": { widget: "ShortTextWidget", colSpan: 4 },
          "PlateYear": { widget: "ShortTextWidget", colSpan: 4 },
          
          "Vin": { widget: "ShortTextWidget", colSpan: 6 },
          "IsImpounded": { widget: "ShortCheckboxWidget", colSpan: 6 },
          
          "Year": { widget: "NumberWidget", options: { maxLength: 4 }, colSpan: 4 },
          "Make": { colSpan: 4, widget: "SelectWidget" },
          "Model": { widget: "ShortTextWidget", colSpan: 4 },
          
          "Style": { colSpan: 6, widget: "SelectWidget" },
          "Color": { colSpan: 6, widget: "SelectWidget" },
          
          "Type": { colSpan: 6, widget: "SelectWidget" },
          "Status": { colSpan: 6, widget: "SelectWidget" },
          
          "Value": { widget: "NumberWidget", colSpan: 4 },
          "RecoveredValue": { widget: "NumberWidget", colSpan: 4 },
          "DamagedValue": { widget: "NumberWidget", colSpan: 4 },
          
          "Location": { widget: "ShortTextWidget", fullWidth: true },
          
          "DateRecovered": { widget: "DateTimeWidget", colSpan: 6 },
          "DateReleased": { widget: "DateTimeWidget", colSpan: 6 },
          
          "Notes": {
              widget: "TextareaWidget",
              fullWidth: true,
              options: { rows: 3 }
          }
      }
  },
  
  // Business Specific
  "Businesses": {
      properties: {
          "BusinessTypeId": { 
              colSpan: 6,
              widget: "SelectWidget"
          },
          "IsVictim": { widget: "ShortCheckboxWidget", colSpan: 6 },
          "Name": { widget: "ShortTextWidget", colSpan: 6 },
          "MainPhoneNumber": { widget: "ShortTextWidget", colSpan: 6 },
          "Alias": { widget: "ShortTextWidget", fullWidth: true },
          "Address": { widget: "ShortTextWidget", fullWidth: true },
          "City": { widget: "ShortTextWidget", colSpan: 4 },
          "State": { widget: "ShortTextWidget", colSpan: 4 },
          "Zip": { widget: "ShortTextWidget", colSpan: 4 }
      }
  },

  // ArrestDetails Definition (nested in Suspect)
  "ArrestDetails": {
      properties: {
          "ArrestDate": { widget: "DateTimeWidget", colSpan: 6 },
          "ArrestingAgency": { widget: "SelectWidget", colSpan: 6 },
          "ArrestType": { colSpan: 4, widget: "SelectWidget" },
          "MultipleClearance": { 
              colSpan: 4, 
              widget: "SelectWidget"
          },
          "ClearanceStatus": { colSpan: 4, widget: "SelectWidget" },
          "ArmedWith": { fullWidth: true, widget: "TagSelectWidget" },
          "BreathTest": { widget: "NumberWidget", colSpan: 6 },
          "BloodTest": { widget: "NumberWidget", colSpan: 6 },
          "TrafficStop": { widget: "ShortCheckboxWidget", colSpan: 4 },
          "VehicleSearched": { widget: "ShortCheckboxWidget", colSpan: 4 },
          "SearchConsented": { widget: "ShortCheckboxWidget", colSpan: 4 },
          "RaceOrEthnicityKnown": { widget: "ShortCheckboxWidget", colSpan: 12 },
          "Location": { widget: "ShortTextWidget", fullWidth: true },
          "WarrantNumber": { widget: "ShortTextWidget", colSpan: 6 },
          "BookingNumber": { widget: "ShortTextWidget", colSpan: 6 },
          "ArrestCharges": { fullWidth: true }
      }
  },

  // ArrestCharge Definition (nested in ArrestDetails)
  "ArrestCharges": {
      properties: {
          "ChargeId": { widget: "NumberWidget", colSpan: 4 },
          "ChargeDisposition": { widget: "ShortTextWidget", colSpan: 4 },
          "ClassificationId": { widget: "NumberWidget", colSpan: 4 }
      }
  },

  // AlsoKnownAs Definition (nested in Person)
  "AlsoKnownAs": {
      properties: {
          "First": { widget: "ShortTextWidget", colSpan: 4 },
          "Middle": { widget: "ShortTextWidget", colSpan: 4 },
          "Last": { widget: "ShortTextWidget", colSpan: 4 }
      }
  },

// ScarsMarksTatoos Definition (nested in Person)
  "ScarsMarksTatoos": {
      properties: {
          "Type": { colSpan: 6, widget: "SelectWidget" },
          "Description": { widget: "ShortTextWidget", colSpan: 6 }
      }
  }
};
